var __jsx = React.createElement;
import React from 'react';
import Link from 'next/link';
import styles from '../../styles/compare/OfferInfo.module.scss';
import Image from 'next/image';
import Button from 'react-bootstrap/Button';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronRight } from '@fortawesome/free-solid-svg-icons';
import { getLoanInterestType } from '../../utils/compare/CompareUtilities';
import * as gtag from '../../cookie/lib/gtag';

var LeasingInfo = function LeasingInfo(props) {
  var details = props.details,
      viewDetails = props.viewDetails,
      sort = props.sort,
      applyParams = props.applyParams,
      product = props.product;

  var handleViewDetails = function handleViewDetails() {
    viewDetails(details.id);
  };

  var providerCol = __jsx(Col, {
    xs: "12",
    md: "4"
  }, details.showLogo ? __jsx(Image, {
    src: details.providerLogo,
    height: details.logoSize.height,
    width: details.logoSize.width,
    alt: details.provider
  }) : __jsx("p", {
    className: "mb-0 font-weight-bold"
  }, details.provider), __jsx("p", {
    className: "".concat(styles.productName, " mb-0")
  }, details.product));

  var aprColumn = __jsx(Col, {
    xs: "4",
    className: "p-2 text-center"
  }, __jsx("p", {
    className: "".concat(styles.indicator, " ")
  }, "DAE"), __jsx("p", {
    className: "".concat(styles.indicatorVal, " ").concat(sort == 'apr' ? styles.active : '', "  mb-0"),
    suppressHydrationWarning: true
  }, Intl.NumberFormat('fr', {
    maximumFractionDigits: 2
  }).format(details.apr), " %"));

  var totalCostColumn = __jsx(Col, {
    xs: "4",
    className: "p-2 text-center"
  }, __jsx("p", {
    className: "".concat(styles.indicator, " ")
  }, "Suma de plat\u0103"), __jsx("p", {
    className: "".concat(styles.indicatorVal, " ").concat(sort == 'totalAmount' ? styles.active : '', "  mb-0"),
    suppressHydrationWarning: true
  }, Intl.NumberFormat('fr', {
    maximumFractionDigits: 0
  }).format(details.totalAmount), " ", details.currency));

  var paymentColumn = __jsx(Col, {
    xs: "4",
    className: "p-2 text-center"
  }, __jsx("p", {
    className: "".concat(styles.indicator, " ")
  }, "Rata lunar\u0103"), __jsx("p", {
    className: "".concat(styles.indicatorVal, " ").concat(sort == 'monthlyPayment' ? styles.active : '', "  mb-0"),
    suppressHydrationWarning: true
  }, Intl.NumberFormat('fr', {
    maximumFractionDigits: 0
  }).format(details.monthlyPayment), " ", details.currency), __jsx("p", {
    className: "mb-0 ".concat(styles.rateType, " ")
  }, getLoanInterestType(details.rateType)));

  var detailsCol = __jsx(Col, {
    xs: "6",
    md: "4",
    className: "py-3 text-center"
  }, __jsx(Button, {
    variant: "link",
    "aria-label": "Detalii",
    onClick: handleViewDetails
  }, __jsx("u", null, "Detalii"), __jsx(FontAwesomeIcon, {
    className: "ml-2",
    icon: faChevronRight,
    height: "16",
    width: "16"
  })));

  var relOpennerTag;

  if (details.hasOwnProperty('apply')) {
    relOpennerTag = details.apply.indexOf(" ".concat(process.env.NEXT_PUBLIC_SITE_URL, " ")) > -1 ? '' : 'noopener';
  } else if (details.hasOwnProperty('webLink')) {
    relOpennerTag = details.webLink.indexOf(" ".concat(process.env.NEXT_PUBLIC_SITE_URL, " ")) > -1 ? '' : 'noopener';
  }

  {
    relOpennerTag = '';
  }

  var onApply = function onApply() {
    if (window.location.hostname.indexOf('conso.ro') > 1) {
      gtag.event('Apply', {
        provider: details.provider,
        product: product
      });
    } else {
      console.log("beta");
    }
  };

  var applyCol = details.hasOwnProperty('apply') && __jsx(Col, {
    xs: "6",
    md: "4",
    className: "d-flex justify-content-center align-items-center mt-2"
  }, __jsx(Link, {
    href: details.apply.indexOf("".concat(process.env.NEXT_PUBLIC_SITE_URL)) > -1 ? "".concat(details.apply).concat(applyParams.length > 0 ? '?' + applyParams : '') : details.apply
  }, __jsx("a", {
    className: "btn btn-primary",
    rel: relOpennerTag,
    target: details.apply.indexOf("".concat(process.env.NEXT_PUBLIC_SITE_URL)) > -1 ? '_self' : '_blank',
    onClick: onApply
  }, "Solicit\u0103 ofert\u0103", __jsx(FontAwesomeIcon, {
    className: "ml-2",
    icon: faChevronRight,
    height: "16",
    width: "16"
  }))));

  return __jsx("div", {
    className: "".concat(styles.root, " mb-5 p-3")
  }, __jsx(Row, {
    className: "".concat(styles.product, " justify-content-between mb-0")
  }, providerCol), __jsx(Row, {
    className: "".concat(styles.product, " mb-0 justify-content-center")
  }, aprColumn, totalCostColumn, paymentColumn), __jsx(Row, {
    className: "mb-0 justify-content-between align-items-center"
  }, detailsCol, applyCol));
};

export default LeasingInfo;